import React from "react";
import { rawColors } from "../../../design-system/tokens/colors";
import type {
  ChevronDirection,
  ChevronDownIconProps,
} from "./ChevronDownIcon.types";

/** Clockwise rotation (degrees about the 20×20 icon centre) per direction. */
const ROTATION: Record<ChevronDirection, number> = {
  down: 0,
  left: 90,
  up: 180,
  right: 270,
};

/** Figma icons/chevron Type=chevron-down — 20×20, stroke #5C5468. */
export const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({
  size = 20,
  color = rawColors.text.mediumEmphasis,
  direction = "down",
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      transform={
        direction === "down" ? undefined : `rotate(${ROTATION[direction]} 10 10)`
      }
    />
  </svg>
);

export default ChevronDownIcon;
